
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  branding = {
    _id: null,
    client_id: null,
    name: "",
    vehicleBranding: "",
    wetWipes: "",
    pagingFile: "",
    showCover: "",
    handSanitizers: "",
    tShirts: "",
    coachBranding: "",
    flags: "",
    carBranding: "",
    luggageTags: "",
    guideCards: "",
    ganesh: "",
    flageStick: "",
    desc: "",
  };

  id = null;

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      this.branding = await doPost("/api/branding/save", this.branding);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.branding = await doGet("/api/branding/" + id + "/detail");
      this.id = this.branding._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
